'use client'

import SdgLink from '@/components/Layout/Navbar/SdgLink'
import React, { useEffect, useState } from 'react'
import { PageMappingType } from '@schleegleixner/react-statamic-api'
import Spinner from '@/components/Elements/Spinner'
import { scrollToElement } from '@/utils/scroll'

export default function TargetFilter({
  page_data,
  sitemap,
}: {
  page_data: PageMappingType
  sitemap: PageMappingType[]
}) {
  const [targetPages, setTargetPages] = useState<PageMappingType[] | null>(null)

  useEffect(() => {
    // filter the sitemap, only allow pages that have the content.filter.sdg_target set
    const filtered = sitemap.filter(page => page.content.sdg_target)
    setTargetPages(filtered)
  }, [sitemap])

  useEffect(() => {
    if (!sitemap) {
      return
    }

    const dimensionPages = sitemap.filter(
      (page: any) => page.content.sdg_target,
    )
    setTargetPages(dimensionPages)
  }, [sitemap])

  if (!targetPages) {
    return (
      <div className="flex h-full items-center justify-center">
        <Spinner />
      </div>
    )
  }

  const onClick = (page: PageMappingType, event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    const targetUrl = page.slug === page_data.slug && page.parent
      ? page.parent.full_url
      : page.full_url
    
    // change the URL without server-rendering
    window.history.pushState({}, '', targetUrl)

    setTimeout(() => {
      scrollToElement('tile-collection', -100)
    }, 500)
  }

  return (
    <div className="flex flex-wrap items-center justify-start gap-4">
      {targetPages.map(page => {
        const isActive = page.slug === page_data.slug
        return (
          <SdgLink
            active={isActive}
            key={page.slug}
            link={
              isActive && page.parent
                ? page.parent.full_url
                : page.full_url
            }
            onClick={(event: React.MouseEvent<HTMLAnchorElement>) => onClick(page, event)}
            preventDefault
            target={page.content.sdg_target}
            {...page}
          />
        )
      })}
    </div>
  )
}
